export default __webpack_public_path__ + "assets/276901.svg";